export default __webpack_public_path__ + "static/media/dairy.018b046a.png";